import React, { useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import { QuickAppointmentContext } from '../../Context';
import useStyles from '../styles';

const Address = () => {
  const { addressData } = useContext(QuickAppointmentContext);

  const classes = useStyles();

  if (addressData.client_location_id)
    return (
      <div className={classes.main}>
        <Typography className={classes.typography} variant="caption">
          {addressData.client_location_name}
        </Typography>
      </div>
    );
  return (
    <div className={classes.main}>
      <Typography className={classes.typography} variant="caption">
        {addressData.address_line_1}
      </Typography>
    </div>
  );
};

export default Address;
